import { LitElement, html } from 'lit';
import { customElement, property, query, state } from 'lit/decorators';

import { FormInputButton } from './theme/form-input-button';
import { StateController } from '../helpers/state/state-management/state-controller';
import { TopicAccessLevel } from '../types';
import { getMainPage } from '../helpers/page-name';
import { sendInviteEmails } from '../helpers/api/topics-api';
import topicData from '../helpers/state/topic-data';
import { undefinedIfEmpty } from '../helpers/utils';
import { validateEmail } from '../helpers/strings';

@customElement('emails-invite-component')
export class EmailsInviteComponent extends LitElement {
    static amplitude_callsite: string = 'Emails Invite Button';

    @property()
    mode: string = 'view-only';

    @query('#emailAddress')
    emailAddressElement!: FormInputButton;

    @property({ type: String })
    error: string = 'An error has occurred. Try again later.';

    @property({ type: String })
    undefinedMessage: string = 'Please input valid email addresses.';

    @property({ type: String })
    successMessage: string = 'Invites sent successfully.';

    @state()
    topic_id?: string;

    @state()
    topic_key?: string;

    @state()
    success: boolean = false;


    private readonly bindTopicState = new StateController(this, topicData);

    render() {
        return html`
            ${this.success ? html`<div class="successMessage">${this.successMessage}</div>` :
            html`
            <form-input-button
                id="emailAddress"
                readonly="false"
                label="Send to Email"
                placeholder="Enter email addresses (comma separated)"
                @submit="${this.validateAndInvite}"
            >
                <slot></slot>
            </form-input-button>
            `}
            <error-toast id="errorToast"></error-toast>
        `;
    }

    async validateAndInvite(e: any) {
        const text = undefinedIfEmpty(this.emailAddressElement.value);
        await getMainPage().errorToastElement.tryOrErrorToast(async () => {
            if (text === undefined) {
                getMainPage().errorToastElement.showToast(this.undefinedMessage);
                return;
            }
            const emailsList = text.split(',').map((item) => item.trim());
            const allValidEmails = emailsList.every((item) => validateEmail(item));
            if (allValidEmails) {
                await sendInviteEmails(
                    EmailsInviteComponent.amplitude_callsite,
                    this.topic_id ?? topicData.topicId,
                    this.mode === 'collaborative'
                        ? TopicAccessLevel.Addpointer
                        : TopicAccessLevel.Reader,
                    emailsList,
                    this.topic_key ?? topicData.topicKey
                );
                this.success = true;
                this.requestUpdate();
                // wait 5 seconds before hiding the success message
                setTimeout(() => {
                    this.success = false;
                    this.requestUpdate();
                }, 3000);
            } else {
                getMainPage().errorToastElement.showToast(this.undefinedMessage);
                return;
            }
            getMainPage().errorToastElement.showToast(this.successMessage);
        }, this.error);
    }
}
